import { Map } from 'immutable';
// immutable has many good use cases. Read more at: https://immutable-js.github.io/immutable-js/
import { ADD_SUB_PLAN, UPDATE_SUB_PLAN, DELETE_SUB_PLAN, POPULATE_SUB_PLANS } from '@constants/actions';

const initialState = Map({
  subPlanList: [],
  totalCount: 0
});

const SubscriptionPlans = (state = initialState, action: any) => {
  const plan = action.payload ? action.payload.plan : null;
  switch(action.type) {
    case POPULATE_SUB_PLANS:
      const { plans, totalCount } = action.payload;
      return state.set('subPlanList', plans)
        .set('totalCount', totalCount);
      // case ADD_SUB_PLAN:
      // case UPDATE_SUB_PLAN:
      //     return state.set(plan.guid, plan);
      // case DELETE_SUB_PLAN:
      //     return state.delete(plan.guid);
    default:
      return state;
  }
};

export default SubscriptionPlans;